import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';

const StyledButton = styled(Button)(({ theme }) => {
  return {
    margin: theme.spacing(1),
    color: theme.palette.text.primary,
  };
});

const StyledIcon = styled(RefreshIcon)(({ theme }) => {
  return {
    marginRight: theme.spacing(1),
  };
});

const RefreshButton = ({ handleClick }) => {
  return (
    <StyledButton
      aria-label="Refresh"
      variant="outlined"
      color="primary"
      onClick={handleClick}
    >
      <StyledIcon fontSize="small" />
      Refresh
    </StyledButton>
  );
};

RefreshButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
};

export default RefreshButton;
